import React from "react";

import { Lang, useTranslation } from "../../i18n";

const LANGS: Lang[] = ["id", "en"];

export default function LanguageSwitch() {
  const { lang, t, setLang } = useTranslation();

  return (
    <div
      className="d-flex align-items-center gap-1 font-vietnam-500 font-size-14"
      role="group"
      aria-label={t.nav.switchLanguage}
    >
      {LANGS.map((code, index) => (
        <React.Fragment key={code}>
          {index > 0 && <span className="font-white-6">/</span>}
          <button
            type="button"
            onClick={() => setLang(code)}
            aria-pressed={lang === code}
            lang={code}
            className={`btn btn-link p-0 text-uppercase text-decoration-none ${
              lang === code ? "fw-bold font-black-1" : "font-white-6"
            }`}
          >
            {code}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
}
